import { z } from 'zod'

export const ContentfulAssetFileSchema = z.object({
  url: z.string(),
  details: z.object({
    size: z.number(),
    image: z
      .object({
        width: z.number(),
        height: z.number(),
      })
      .optional(),
  }),
  fileName: z.string(),
  contentType: z.string(),
})

export type ContentfulAssetFile = z.infer<typeof ContentfulAssetFileSchema>

export const ContentfulAssetSchema = z.object({
  title: z.string().optional(),
  description: z.string().optional(),
  file: ContentfulAssetFileSchema.optional(),
})

export type ContentfulAsset = z.infer<typeof ContentfulAssetSchema>

export const ContentfulBynderImageSchema = z
  .object({
    extension: z.array(z.string()).optional(),
    height: z.number().optional(),
    id: z.string().optional(),
    isPublic: z.number().optional(),
    description: z.string().nullable().optional(),
    name: z.string().optional(),
    orientation: z.string().optional(),
    original: z.string().nullable().optional(),
    src: z.string().optional(),
    type: z.string().optional(),
    width: z.number().optional(),
    selectedFile: z
      .object({
        fileSize: z.number().nullable().optional(),
        height: z.number().nullable().optional(),
        url: z.string().nullable().optional(),
        width: z.number().nullable().optional(),
      })
      .optional(),
  })
  .passthrough()

export type ContentfulBynderImage = z.infer<typeof ContentfulBynderImageSchema>
